"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var validator_1 = require("validator");
var Input_1 = __importDefault(require("./Input"));
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var NumberInput = function (_a) {
    var setValue = _a.setValue, handleChange = _a.handleChange, props = __rest(_a, ["setValue", "handleChange"]);
    return react_1.default.createElement(Input_1.default, __assign({}, props, { onChange: handleChange }));
};
var convertNumber = function (value) { return (value !== null ? String(value) : ''); };
var ComposedNumberInput = recompose_1.compose(recompose_1.pure, recompose_1.defaultProps({ value: 0, onChange: lodash_1.noop }), recompose_1.renameProp('value', 'numberValue'), recompose_1.mapProps(function (_a) {
    var numberValue = _a.numberValue, rest = __rest(_a, ["numberValue"]);
    return __assign({ numberValue: numberValue ? Number(numberValue) : numberValue }, rest);
}), recompose_1.withState('value', 'setValue', function (_a) {
    var numberValue = _a.numberValue;
    return convertNumber(numberValue);
}), recompose_1.withHandlers({
    handleChange: function (_a) {
        var setValue = _a.setValue;
        return function (value) {
            if (validator_1.isDecimal(value + '0')) {
                // add trailing zero and test if number, so user can write decimal symbol
                setValue(value);
            }
        };
    },
}), recompose_1.lifecycle({
    componentWillReceiveProps: function (_a) {
        var numberValue = _a.numberValue, value = _a.value, onChange = _a.onChange, setValue = _a.setValue;
        var oldValue = this.props.value;
        if (value !== oldValue) {
            onChange(value === '0' ? 0 : Number(value) || null);
        }
        else if (numberValue && numberValue !== Number(value)) {
            setValue(String(numberValue));
        }
    },
}), recompose_1.mapProps(function (_a) {
    var numberValue = _a.numberValue, rest = __rest(_a, ["numberValue"]);
    return (__assign({}, rest));
}))(NumberInput);
exports.default = ComposedNumberInput;
exports.FormNumberInput = reduxFormWrappers_1.formWrapper(ComposedNumberInput);
//# sourceMappingURL=NumberInput.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/NumberInput.js
// module id = 2059
// module chunks = 0